// The column definitions of every leg, fetched once. They change with a deployment, not with a
// user's session, so one request serves every tracker screen mounted after it - and a screen that
// mounts while the first request is in flight shares it rather than repeating it.

import { useEffect, useState } from 'react';

import { getDeliveryColumns } from '../api.js';

let pending = null;

export default function useColumns() {
  const [state, setState] = useState({ legs: null, error: null });

  useEffect(() => {
    let cancelled = false;

    pending ??= getDeliveryColumns().catch((err) => {
      // Not cached: a failed request is retried by the next mount, not remembered.
      pending = null;
      throw err;
    });

    pending
      .then((legs) => {
        if (!cancelled) setState({ legs, error: null });
      })
      .catch((err) => {
        if (!cancelled) setState({ legs: null, error: err.message });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
